import { render } from "./SuperPacmanInstallmentList.vue?vue&type=template&id=a8121394&scoped=true&ts=true"
import script from "./SuperPacmanInstallmentList.vue?vue&type=script&lang=ts"
export * from "./SuperPacmanInstallmentList.vue?vue&type=script&lang=ts"

import "./SuperPacmanInstallmentList.vue?vue&type=style&index=0&id=a8121394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8121394"]])

export default __exports__